import * as React from "react";
import { Button, Tooltip } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { TreeActionsPort } from "src/pages/ManagementPage/objects/ports";

interface PropsUpToObject {
  store: TreeActionsPort;
}

export const UpToObject: React.FC<PropsUpToObject> = ({ store }) => (
  <Tooltip title="Перейти к объекту-владельцу">
    <Button
      icon={<ArrowLeftOutlined />}
      onClick={() => store.safeUpToObject()}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        padding: 0,
        color: "#E43D00",
      }}
    >
      К объекту
    </Button>
  </Tooltip>
);
